import React, { useState } from 'react';
import FsLightbox from "fslightbox-react";
import { useParams } from 'react-router-dom';
import projects from '../data/projects';
import { useTranslation } from 'react-i18next';

const ProjectDetailsSec = ({ className = "space-top space-extra-bottom overflow-hidden" }) => {
  const [toggler, setToggler] = useState(false);
  const { slug } = useParams();
  const { t } = useTranslation();
  const project = slug ? projects.find((p) => p.slug === slug) : null;

  const mainImage = project?.detailsImage || 'assets/img/project/project_inner_1.jpg';
  const mainTitle = project?.title || t('sections.projectDetailsSec.mainTitle','Preventing DDoS Attacks');
  return (
    <section className={className}>
      <div className="container">
        <div className="row">
          <div className="col-xxl-8 col-lg-8">
            <div className="mb-30">
              <div className="page-img mb-30" data-cue="slideInUp">
                <img src={mainImage} alt={mainTitle} />
              </div>
              <div className="project-content" data-cue="slideInUp">
                <h4 className="mb-10">{mainTitle}</h4>
                <p className="mb-35">{t('sections.projectDetailsSec.intro','Preventing DDoS Attacks is a critical aspect of cybersecurity that focuses on safeguarding systems, networks, and services from distributed denial-of-service (DDoS) attacks. These attacks overwhelm a target with a flood of traffic, rendering it inaccessible to legitimate users. Solutions to prevent DDoS attacks include traffic filtering.')}</p>
                <h5 className="fw-semibold mb-15">{t('sections.projectDetailsSec.details_heading','Project Details')}</h5>
                <p className="mb-40">{t('sections.projectDetailsSec.details_text','Preventing DDoS (Distributed Denial-of-Service) attacks involves a combination of proactive measures and responsive strategies. Key steps include implementing rate limiting, which controls traffic flow to prevent server overload, and using firewalls.')}</p>

                <div className="row gx-40 gy-4">
                  <div className="col-md-6">
                    <div className="page-img video-wrap1">
                      <img className="w-100" src="assets/img/project/project_inner_2.jpg" alt="project" />
                        <a 
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setToggler(!toggler);
                            }}
                            className="play-btn"
                            >
                            <i className="fas fa-play"></i>
                        </a>
                        <FsLightbox
                            toggler={toggler}
                            sources={[
                            "https://www.youtube.com/watch?v=Z4F3AXvrLKo"
                            ]}
                        />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h5 className="mt-n2 fw-semibold">{t('sections.projectDetailsSec.sub_heading','Secur Preventing the World')}</h5>
                    <p>{t('sections.projectDetailsSec.sub_text','Leverage specialized cloud-based DDoS protection services to detect and absorb high-volume attacks')}</p>
                    <div className="check-list">
                      <ul>
                        <li><i className="fas fa-shield-check"></i> {t('sections.projectDetailsSec.checks.0','Traffic Filtering and Rate Limiting')}</li>
                        <li><i className="fas fa-shield-check"></i> {t('sections.projectDetailsSec.checks.1','Firewalls and Intrusion Detection')}</li>
                        <li><i className="fas fa-shield-check"></i> {t('sections.projectDetailsSec.checks.2','DDoS Mitigation Security Services')}</li>
                        <li><i className="fas fa-shield-check"></i> {t('sections.projectDetailsSec.checks.3','Monitoring and Alerts Security')}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xxl-4 col-lg-4">
            <aside className="sidebar-area">
              <div className="widget project_info" data-cue="slideInUp">
                <h3 className="widget_title">{t('sections.projectDetailsSec.project_info_title','Project Information')}</h3>
                <ul className="project_info_list">
                  <li className="single-project-info">
                    <div className="box-icon"><i className="far fa-user"></i></div>
                    <div className="box-content">
                      <h5 className="box-title">{t('sections.projectDetailsSec.client_label','Client:')}</h5>
                      <p className="box-text">{t('sections.projectDetailsSec.client_value','ABC Cybersecurity')}</p>
                    </div>
                  </li>
                  <li className="single-project-info">
                    <div className="box-icon"><i className="far fa-map-marker-alt"></i></div>
                    <div className="box-content">
                      <h5 className="box-title">{t('sections.projectDetailsSec.location_label','Location:')}</h5>
                      <p className="box-text">{t('sections.projectDetailsSec.location_value','Chapel Hill Street, Stamford')}</p>
                    </div>
                  </li>
                  <li className="single-project-info">
                    <div className="box-icon"><i className="fal fa-calendar-days"></i></div>
                    <div className="box-content">
                      <h5 className="box-title">{t('sections.projectDetailsSec.date_label','Project Date:')}</h5>
                      <p className="box-text">{t('sections.projectDetailsSec.date_value','10 January, 2025')}</p>
                    </div>
                  </li>
                  <li className="single-project-info">
                    <div className="box-icon"><i className="far fa-layer-group"></i></div>
                    <div className="box-content">
                      <h5 className="box-title">{t('sections.projectDetailsSec.category_label','Category:')}</h5>
                      <p className="box-text">{t('sections.projectDetailsSec.category_value','Preventing DDoS Attack')}</p>
                    </div>
                  </li>
                  <li className="single-project-info">
                    <div className="box-icon"><i className="fas fa-dollar-sign"></i></div>
                    <div className="box-content">
                      <h5 className="box-title">{t('sections.projectDetailsSec.cost_label','Cost:')}</h5>
                      <p className="box-text">{t('sections.projectDetailsSec.cost_value','12,30.00')}</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="widget" data-cue="slideInUp">
                <h3 className="widget_title">{t('sections.projectDetailsSec.brochure_title','Brochure')}</h3>
                <ul className="brochure_list">
                  <li className="single-brochure">
                    <div className="box-icon"><i className="fas fa-file-pdf"></i></div>
                    <div className="box-content">
                      <h5 className="box-title">{t('sections.projectDetailsSec.brochures.0.title','Service Brochure')}</h5>
                      <div className="meta"><span>{t('sections.projectDetailsSec.brochures.0.format','PDF')}</span><span>{t('sections.projectDetailsSec.brochures.0.size','12 MB')}</span></div>
                    </div>
                    <a href="#" className="download-btn"><i className="fal fa-download"></i></a>
                  </li>
                  <li className="single-brochure">
                    <div className="box-icon"><i className="fas fa-file-pdf"></i></div>
                    <div className="box-content">
                      <h5 className="box-title">{t('sections.projectDetailsSec.brochures.1.title','Company Profile')}</h5>
                      <div className="meta"><span>{t('sections.projectDetailsSec.brochures.1.format','DOCS')}</span><span>{t('sections.projectDetailsSec.brochures.1.size','22 MB')}</span></div>
                    </div>
                    <a href="#" className="download-btn"><i className="fal fa-download"></i></a>
                  </li>
                </ul>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetailsSec;